import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

type PopoverOptionsMenuProps = { onClick: (e: React.MouseEvent<HTMLElement>) => void }

export function PopoverOptionsMenuIcon({ onClick }: PopoverOptionsMenuProps) {
  return (
    <>
      <div className="optionsIcon" onClick={onClick}>
        <MoreHorizIcon fontSize="small" />
      </div>
    </>
  )
}
